import { intl } from '@fullstory/intl';

export const TWO_EVENTS_REQUIRED_TEXT = intl.formatMessage({
  defaultMessage: 'At least two events are required.',
  id: 'V87o55',
});

export const TWO_OCCURRENCES_REQUIRED_TEXT = intl.formatMessage({
  defaultMessage: 'At least two occurrences are required.',
  id: 'ZymBxF',
});

export const SAME_SESSION_LABEL = intl.formatMessage({
  defaultMessage: 'within the same session',
  id: 'rkptFF',
});
export const ACROSS_SESSIONS_LABEL = intl.formatMessage({
  defaultMessage: 'across any number of sessions',
  id: '6HeCRc',
});

const SAME_COMPLETE_SESSION_LABEL = intl.formatMessage({
  defaultMessage: 'within the same complete session',
  id: 'VqZnV+',
});
const ACROSS_COMPLETE_SESSIONS_LABEL = intl.formatMessage({
  defaultMessage: 'across any number of complete sessions',
  id: 'R4fztf',
});

export const SessionConstraintsLabel = (
  inSameSession: boolean | undefined,
  completeSessions: boolean | undefined,
): string =>
  inSameSession
    ? completeSessions
      ? SAME_COMPLETE_SESSION_LABEL
      : SAME_SESSION_LABEL
    : completeSessions
    ? ACROSS_COMPLETE_SESSIONS_LABEL
    : ACROSS_SESSIONS_LABEL;
